




















































































































































































































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import api from "../services/api";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { Grid } from "@progress/kendo-vue-grid";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateInput from "@/components/DateInput.vue";
import {
  RevaluationTransaction,
  RevaluationItem,
  BookRevaluationItem,
} from "../models/Revaluation";

interface Data {
  expandedIds: number[];
  rowItems: Record<number, { items: RevaluationItem[] }>;
  columns: any[];
  gridColumns: any[];
  itemColumns: any[];
  // Aktív rendezés (kendo grid sort), a szerver-oldali rendezéshez kötve.
  sort: any[];
  // A főkönyvi számok évenként cache-elve (a választó a tranzakció éve szerint tölt).
  accountsByYear: Record<number, any[]>;
}
interface Methods {
  markExpanded(items: RevaluationTransaction[]): RevaluationTransaction[];
  toggleExpand(trans: RevaluationTransaction): void;
  onSortChange(e: any, apiSearch: any): void;
  onFilterInput(apiSearch: any, field: string, sub: string, value: any): void;
  setBusy(value: boolean): void;
  ensureAccounts(year: number): Promise<void>;
  accountsFor(year: number): any[];
  onResetFiltering(): void;
  onToggleSelect(item: RevaluationItem, value: boolean): void;
  onSelectItem(item: RevaluationItem): void;
  markAll(trans: RevaluationTransaction): void;
  unmarkAll(trans: RevaluationTransaction): void;
  applyDefaults(item: RevaluationItem): void;
  recalcTotal(item: RevaluationItem): void;
  onAccnoNewChange(selected: any, item: RevaluationItem): void;
  book(trans: RevaluationTransaction): void;
  selectedCount(trans: RevaluationTransaction): number;
  markableCount(trans: RevaluationTransaction): number;
  formatNumber(n: number): string;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    ApiSearchPage,
    Grid,
    LookupComboBox,
    CheckBox,
    DateInput,
  },

  data(): Data {
    return {
      expandedIds: [],
      rowItems: {},
      accountsByYear: {},
      // Szerver-oldali rendezés (és az 'accDate' range szűrő). A title kell a rendezéshez.
      columns: [
        { field: "id", title: "Azonosító" },
        { field: "accEvent", title: "Esemény", filterable: false },
        { field: "accDate", title: "Dátum", filterable: false, range: true },
        { field: "periodName", title: "Időszak", filterable: false },
        { field: "partnerName", title: "Partner", filterable: false },
        { field: "transTypeName", title: "Tranzakció típusa", filterable: false },
        { field: "statusName", title: "Állapot", filterable: false },
        { field: "createdBy", title: "Létrehozó", filterable: false },
        { field: "insDate", title: "Létrehozás dátuma", filterable: false },
        { field: "remark", title: "Megjegyzés", filterable: false },
        // Kapcsoló-szűrő (nem oszlop): a teljesen átértékelt fejek mutatása. Csak a filter-modellbe kerül.
        { field: "showFullyRevalued", title: "Teljesen átértékeltek is", sortable: false },
      ],
      sort: [],
      gridColumns: [
        { cell: "toggleCell", title: "", width: "60px", filterable: false, sortable: false },
        { field: "id", title: "Azonosító", width: "100px" },
        { field: "accEvent", title: "Esemény" },
        { field: "accDate", title: "Dátum", width: "110px", className: "right_text" },
        { field: "periodName", title: "Időszak", width: "130px" },
        { field: "partnerName", title: "Partner" },
        { field: "transTypeName", title: "Tranzakció típusa", width: "150px" },
        { field: "statusName", title: "Állapot", width: "120px" },
        { cell: "fullyRevaluedCell", title: "Átértékelés", width: "150px", sortable: false, headerClassName: "center_text" },
        { field: "createdBy", title: "Létrehozó", width: "140px" },
        { field: "insDate", title: "Létrehozás dátuma", width: "150px", className: "right_text" },
        { field: "remark", title: "Megjegyzés" },
        { filterable: false, sortable: false, width: 0 },
      ],
      itemColumns: [
        { cell: "selectCell", title: "Jelöl", width: "70px", filterable: false, headerClassName: "center_text" },
        { field: "accNo", title: "Főkönyvi szám", width: "110px" },
        { cell: "accNoNameCell", title: "Megnevezés" },
        { cell: "revaluedCell", width: "140px", filterable: false, sortable: false },
        { field: "accSign", title: "T/K", width: "70px" },
        { cell: "totalCell", title: "Összeg", width: "110px", filterable: false },
        { field: "currency", title: "Pénznem", width: "90px" },
        { cell: "exchangeRateOldCell", title: "Régi árfolyam", width: "110px", filterable: false },
        { cell: "exchangeRateNewCell", title: "Új árfolyam", width: "110px", filterable: false },
        { field: "totalNew", title: "Átértékelés összege", width: "160px", filterable: false, format: "{0:#,##0.00}", className: "text-end" },
        { cell: "accnoNewCell", title: "Átértékelési főkönyvi szám", width: "260px", filterable: false },
        { cell: "accnoNewNameCell", title: "Átért. fősz. megnevezése", width: "220px", filterable: false },
        { cell: "noteCell", title: "Megjegyzés", width: "200px", filterable: false },
      ],
    };
  },

  methods: {
    // A tranzakció évéhez tartozó főkönyvi számok betöltése (cache-elve, egyszer évenként).
    async ensureAccounts(year) {
      if (!year || this.accountsByYear[year]) return;
      try {
        const list = await api.GetInvoiceMirrorsByYear(year);
        this.$set(this.accountsByYear, year, list || []);
      } catch (e) {
        this.$set(this.accountsByYear, year, []);
      }
    },

    accountsFor(year) {
      return this.accountsByYear[year] || [];
    },

    onResetFiltering() {
      this.expandedIds = [];
      this.rowItems = {};
    },

    // A szűrőmezők értékét beírjuk az ApiSearch filterbe, de az auto-újratöltést elnyomjuk
    // (stopFilterLoad), így a szűrés csak a "Lista frissítése" gombra él élesbe.
    onFilterInput(apiSearch, field, sub, value) {
      if (!apiSearch || !apiSearch.filter) return;
      apiSearch.stopFilterLoad = true;
      apiSearch.filter.filters[field][sub] = value;
    },

    // A meglévő globális busy indicator (lásd @/utils/busyIndication).
    setBusy(value) {
      eventBus.$emit("busy-message", value);
    },

    // A kendo grid fejléc-rendezését az ApiSearch sort-modelljéhez kötjük (szerver-oldali rendezés).
    onSortChange(e, apiSearch) {
      this.sort = e.sort || [];
      if (!apiSearch || !apiSearch.sort) return;
      apiSearch.sort.definitions.forEach((d: any) => {
        d.order = "None";
      });
      const active = (e.sort || [])[0];
      if (active && active.dir) {
        const def = apiSearch.sort.definitions.find((d: any) => d.field === active.field);
        if (def) def.order = active.dir === "desc" ? "Descending" : "Ascending";
      }
    },

    // A nyitott állapotot és a betöltött tételeket külön tartjuk, és minden
    // renderkor rávetítjük a tranzakciókra (összepontozás minta).
    markExpanded(items) {
      return items.map((item) => ({
        ...item,
        expanded: this.expandedIds.includes(item.id),
        ...(this.rowItems[item.id] || {}),
      }));
    },

    async toggleExpand(trans) {
      const idx = this.expandedIds.indexOf(trans.id);
      if (idx !== -1) {
        this.expandedIds.splice(idx, 1);
        return;
      }

      // Az átértékelési számla választóhoz a tranzakció évének főkönyvi számai kellenek.
      await this.ensureAccounts(trans.year);

      // Lenyitáskor (ha még nincs betöltve) lekérjük a tételeket.
      if (!this.rowItems[trans.id]) {
        const loaded = await api.GetRevaluationItems(trans.id);
        this.$set(this.rowItems, trans.id, {
          items: loaded.map((i) => ({ ...i, selected: false, accnoNewName: "" })),
        });
      }

      this.expandedIds.push(trans.id);
    },

    // A TruFinance CheckBox az új értéket adja a @change-ben (nem v-model).
    onToggleSelect(item, value) {
      if (item.revalued) return;
      item.selected = value;
      this.onSelectItem(item);
    },

    // K2D treff::clicked – megjelöléskor beállítjuk az alapértékeket és kiszámoljuk a különbözetet.
    onSelectItem(item) {
      if (item.revalued) {
        // Már átértékelt tétel nem jelölhető.
        item.selected = false;
        eventBus.$emit("warn", "Ez a tétel már át lett értékelve!");
        return;
      }
      if (item.selected) {
        this.applyDefaults(item);
      }
    },

    applyDefaults(item) {
      if (!item.exchangeRateOld) item.exchangeRateOld = item.exchangeRate;
      if (!item.exchangeRateNew) item.exchangeRateNew = item.exchangeRate;
      this.recalcTotal(item);
    },

    // K2D: pb_treff – minden (még nem átértékelt) tétel megjelölése.
    markAll(trans) {
      (trans.items || []).forEach((i) => {
        if (!i.revalued && !i.selected) {
          i.selected = true;
          this.applyDefaults(i);
        }
      });
    },

    // K2D: pb_treff0 – minden jelölés törlése.
    unmarkAll(trans) {
      (trans.items || []).forEach((i) => {
        i.selected = false;
      });
    },

    // K2D: total_new = total / exchange_rate_old * exchange_rate_new - total (az átértékelési különbözet),
    // 2 tizedesjegyre kerekítve (d_g_project_item.srd total_new oszlop: decimal(2)).
    recalcTotal(item) {
      const old = Number(item.exchangeRateOld) || 0;
      const neu = Number(item.exchangeRateNew) || 0;
      const total = Number(item.total) || 0;
      item.totalNew = old !== 0 ? Math.round(((total / old) * neu - total) * 100) / 100 : 0;
    },

    onAccnoNewChange(selected, item) {
      if (!selected || !selected.id) {
        item.accnoNewId = 0;
        item.accnoNewAccno = "";
        item.accnoNewName = "";
        return;
      }
      item.accnoNewId = selected.id;
      item.accnoNewAccno = selected.accno;
      item.accnoNewName = selected.nationalLong;
    },

    selectedCount(trans) {
      return (trans.items || []).filter((i) => i.selected).length;
    },

    markableCount(trans) {
      return (trans.items || []).filter((i) => !i.revalued && !i.selected).length;
    },

    async book(trans) {
      const selected = (trans.items || []).filter((i) => i.selected);
      if (selected.length === 0) {
        eventBus.$emit("warn", "Nem jelölt meg egy tételt sem!");
        return;
      }
      const missingAcc = selected.find((i) => !i.accnoNewId || i.accnoNewId <= 1);
      if (missingAcc) {
        eventBus.$emit(
          "error",
          "Minden megjelölt tételhez válasszon átértékelési főkönyvi számot!"
        );
        return;
      }

      const payloadItems: BookRevaluationItem[] = selected.map((i) => ({
        itemId: i.itemId,
        exchangeRateOld: i.exchangeRateOld,
        exchangeRateNew: i.exchangeRateNew,
        accnoNewId: i.accnoNewId,
        totalNew: i.totalNew,
        note: i.note,
      }));

      try {
        const newId = await api.BookRevaluation({
          transId: trans.id,
          items: payloadItems,
        });
        eventBus.$emit("success", `Az átértékelés könyvelve. Új tranzakció: #${newId}`);
        // Az átértékelt tranzakció a következő listázáskor frissül (a tételek 'revalued' lesz).
        this.expandedIds = [];
        this.rowItems = {};
        eventBus.$emit("revaluation:reload");
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", "Az átértékelés könyvelése nem sikerült!");
      }
    },

    formatNumber(n) {
      if (n === null || n === undefined) return "";
      return Number(n).toLocaleString("hu-HU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
});
